import api from './apiClient';

// Lambda-backed service for the "newsTaskRecord" collection
const collection = '/newsTaskRecord';

const newsTaskRecordService = {
  async getListData(filters = []) {
    const queryString = filters.length > 0 
      ? `?filter=${encodeURIComponent(JSON.stringify(filters))}` 
      : '';
    return await api.get(`${collection}${queryString}`);
  },
  async getListObjectDataById(id) {
    return await api.get(`${collection}/${encodeURIComponent(id)}`);
  },
  async updateListObjectDataById(id, patch) {
    const body = patch && typeof patch === 'object' ? patch : {};
    return await api.put(`${collection}/${encodeURIComponent(id)}`, body);
  },
  async insertObjectToArrayData(obj) {
    const body = obj && typeof obj === 'object' ? obj : {};
    return await api.post(collection, body);
  },
  async deleteObjectInArrayData(id) {
    await api.delete(`${collection}/${encodeURIComponent(id)}`);
    return true;
  },
};

export default newsTaskRecordService;

